export const COMPETENCIES_TYPE_REQUEST = "COMPETENCIES_TYPE_REQUEST";
export const COMPETENCIES_TYPE_SUCCESS = "COMPETENCIES_TYPE_SUCCESS";
export const COMPETENCIES_TYPE_FAIL = "COMPETENCIES_TYPE_FAIL";
export const COMPETENCIES_TYPE_CLEAR_ERRORS = "COMPETENCIES_TYPE_CLEAR_ERRORS";
